import React, {useEffect, useState, Suspense, useContext} from 'react';
import { CategoryTitle, HomeContainer, HomeItemContainer,HomeItemTitle,HomeItemReference, HomeItemImage, HomeItemInfo, OfferContainer, OfferItemAddToCartButton, OfferItemAddToCartContainer, OfferItemAddToCartSelect, OfferItemContainer, OfferItemDescription,OfferItemDiscount, OfferItemImage, OfferItemImageButton, OfferItemInfo, OfferItemOldPrice, OfferItemPrice, OfferItemPriceContainer, OfferItemReference, OfferItemTitle, HomeImageCarousel, ExplanationContent } from './style';
import { BiSolidCart, BiPhone } from 'react-icons/bi';
import Carousel from '../../Components/Carousel';
import OptimizedImage from '../../Components/OptimizedImage';

//API access
import OfferLoader from './OfferLoader';
import ProductService from '../../Utils/API/products';
import AuthService from '../../AuthService';
import { DetailsContentSimilarProducts, DetailsContentSimilarProductsContainer, DetailsContentSimilarProductsItem, DetailsContentSimilarProductsItemImage, DetailsContentSimilarProductsItemTitle, DetailsContentSimilarProductsTitle } from '../Details/style';
import { Tooltip } from 'react-tooltip'
//Help icon from react-icons
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import ExplanationItem from '../../Components/Miscellaneous/Explanation';
import { FaRegAddressCard } from 'react-icons/fa';
import { TbTruckDelivery } from 'react-icons/tb';
import { LiaUserFriendsSolid } from 'react-icons/lia';
import FloatingActionButton from '../../Components/Miscellaneous/FloatingActionButton';
import { BsTelephone } from 'react-icons/bs';

import LazyLoad from 'react-lazyload';
import { Link } from 'react-router-dom';
import CarouselLoader from './CarouselLoader';
import { Loader } from '../Login/style';
import CartService from '../../Utils/API/cart';
import Flicking from '@egjs/react-flicking';
import { UtilsContext } from '../../Context/UtilsContext';
import { useAuth } from '../../Context/Auth';
import { MdEuro } from 'react-icons/md';
import ReactGA from 'react-ga4';


function getScreenWidth(){
    return window.innerWidth;
}

export default function Home() {

    const {loggedIn} = useAuth();


    useEffect(() => {
        ProductService.getOfferProducts().then(data => {
            setItems(data);
        });

        // Comprobar si los datos ya fueron inyectados por Lambda@Edge
        if (window.__INITIAL_HOME_DATA__) {
            console.log('✅ Using pre-loaded home data from Lambda@Edge');
            setHomePage(window.__INITIAL_HOME_DATA__);
            // Limpiar los datos del window para liberar memoria
            delete window.__INITIAL_HOME_DATA__;
        } else {
            // Fallback: hacer petición normal si no hay datos pre-inyectados
            console.log('⚠️ Lambda@Edge data not found, fetching from API');
            fetch('https://api.rb.beeapp.es/home', {
                'Content-Type': 'application/json',
            }).then(response => {
                response.json().then(data => {
                    setHomePage(data);
                });
            }).catch(error => {
                console.log(error);
            });
        }


        fetch('https://api.rb.beeapp.es/analytics/interested/'+AuthService.getUser()?._id, {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + AuthService.getToken(),
        }).then(response => {
            response.json().then(data => {
                setRecomendation(data);
            }
            );
        }
        ).catch(error => {
            console.log(error);
        });

        
    }, []);


    async function addToCart(productID, quantity){
        let o = {
            id: productID,
            quantity: quantity,
        }
        await CartService.addProductToCart(o);
    }


        //create a form with hidden input pr

    const [homePage , setHomePage] = useState([]);
    const [items, setItems] = useState([]);
    const [recomendation, setRecomendation] = useState([]);
    const [screenWidth, setScreenWidth] = useState(null);
    const {isMegaMenuOpen} = useContext(UtilsContext);

    //hook for screenresize event listener
    useEffect(() => {
        setScreenWidth(window.innerWidth);
        window.addEventListener('resize', () => {
            setScreenWidth(window.innerWidth);
        });
    }, []);

    function analytics(ID, x, y){
        fetch('https://api.rb.beeapp.es/analytics/track', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                userID: AuthService.getUser() ? AuthService.getUser()._id : null,
                eventType: 'click',
                Date: new Date(),
                Referer: window.location.href,
                cursorPosition: {
                    x: x,
                    y: y,
                },
                productID: ID,

            })
        }).then(response => {
            console.log(response);
        }).catch(error => {
            console.log(error);
        });
    }



    return (
        <HomeContainer>
            {/* Hero Section con imagen a ancho completo */}
            <div style={{
                width: '100vw',
                position: 'relative',
                left: '50%',
                right: '50%',
                marginLeft: '-50vw',
                marginRight: '-50vw',
                overflow: 'hidden',
                marginBottom: '20px',
                marginTop: '-40px'
            }}>
                {/* Carousel de imágenes */}
                <Flicking
                    tag="div"
                    viewportTag="div"
                    cameraTag="div"
                    duration={1000}
                    gap={10}
                    circular={true}
                    style={{
                        width: '100%',
                        height: 'auto'
                    }}
                >
                {
                    homePage?.slider?.length > 0 && homePage.slider.map((item, index) => (
                        <div key={index} style={{
                            width: '100%',
                            position: 'relative'
                        }}>
                            <Link to={item.link} style={{
                                display: 'block',
                                width: '100%'
                            }}>
                                <OptimizedImage
                                    src={item.image}
                                    alt={`Slide ${index + 1}`}
                                    width={1920}
                                    fit="scale-down"
                                    quality={90}
                                    lazy={index > 0}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 75%, rgba(0,0,0,0.8) 85%, rgba(0,0,0,0))',
                                        maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1) 75%, rgba(0,0,0,0.8) 85%, rgba(0,0,0,0))'
                                    }}
                                />
                            </Link>
                        </div>
                    ))
                }
                </Flicking>

            </div>

            {/* Sección "Quienes Somos" - superpuesta sobre el hero */}
            <div style={{
                marginTop: screenWidth > 800 ? '-350px' : '-80px',
                position: 'relative',
                zIndex: 2
            }}>
                <ExplanationContent
                    zIndex={isMegaMenuOpen ? 0 : 0}
                >
                    <Link to="/sobre-nosotros"
                    style={{
                        textDecoration: 'none',
                    }}
                    >
            <ExplanationItem title="Quienes Somos" icon={<FaRegAddressCard/>}>
                Somos una distribuidora de productos de papelería, material escolar y de oficina. Nuestro objetivo es ofrecerte los mejores productos al mejor precio.

            </ExplanationItem>
            </Link>
            <ExplanationItem title="Entregas Rápidas" icon={<TbTruckDelivery/>}>
                Para nosotros es muy importante que recibas tus pedidos lo antes posible, por eso ofrecemos entregas en 24/48 horas<sup>*</sup>.
            </ExplanationItem>
            <ExplanationItem title="¿Por qué nosotros?" icon={<LiaUserFriendsSolid/>}>
                La distribución de productos de papelería puede ser tediosa, por eso te ofrecemos un servicio personalizado y adaptado a tus necesidades.
            </ExplanationItem>
            <ExplanationItem title="Precios Competitivos" icon={<MdEuro/>}>
                Nuestros precios son los más competitivos del mercado, ofreciéndote la mejor relación calidad-precio.
            </ExplanationItem>
            </ExplanationContent>
            </div>

                    <DetailsContentSimilarProductsTitle>Ofertas</DetailsContentSimilarProductsTitle>

                <Carousel
                    minSlideWidth={350}
                    autoPlay={true}
                    interval={5000}
                >
    {
      items?.length > 0 ?
      items
        .filter(item => item)
        .map((item, index) => (
          <div key={index}>
            <OfferItemContainer
                onClick={(e) => {
                    analytics(item._id, e.clientX, e.clientY);
                    window.location.href = '/details/'+item.productURL;
                }}
            >
              {/* Imagen del producto */}
              <div style={{
                  width: '100%',
                  height: '280px',
                  backgroundColor: '#f9fafb',
                  position: 'relative',
                  overflow: 'hidden',
                  borderRadius: '12px',
                  cursor: 'pointer'
              }}>
                  <OptimizedImage
                      src={item.images[0] || 'https://cdn.beeapp.es/distribucionesrb/NoImage.png'}
                      alt={item.name}
                      width={250}
                      height={250}
                      fit="contain"
                      quality={80}
                      alt={item.name}
                      style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          padding: '1.5rem',
                          transition: 'transform 0.3s ease'
                      }}
                      className="offer-image"
                  />

                  {/* Badge de oferta */}
                  <div style={{
                      position: 'absolute',
                      top: '1rem',
                      left: '1rem',
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      padding: '0.5rem 0.75rem',
                      borderRadius: '8px',
                      fontSize: '0.875rem',
                      fontWeight: 700,
                      boxShadow: '0 4px 8px rgba(220, 53, 69, 0.3)',
                      zIndex: 10
                  }}>
                      OFERTA
                  </div>

                  {/* Badge de stock */}
                  {item.stock > 0 && (
                      <div style={{
                          position: 'absolute',
                          top: '1rem',
                          right: '1rem',
                          backgroundColor: '#028322',
                          color: '#fff',
                          padding: '0.35rem 0.65rem',
                          borderRadius: '6px',
                          fontSize: '0.75rem',
                          fontWeight: 600
                      }}>
                          En Stock
                      </div>
                  )}
              </div>

              {/* Detalles del producto */}
              <div style={{
                  padding: '1.25rem',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.75rem',
                  flex: 1
              }}>
                  {/* Referencia */}
                  <span style={{
                      fontSize: '0.75rem',
                      color: '#6b7280',
                      fontWeight: 500
                  }}>
                      Ref. {item.reference}
                  </span>

                  {/* Nombre */}
                  <h3 style={{
                      margin: 0,
                      fontSize: '1rem',
                      fontWeight: 600,
                      color: '#1f2937',
                      lineHeight: '1.4',
                      height: '2.8rem',
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      cursor: 'pointer'
                  }}>
                      {item.name}
                  </h3>

                  {/* Unidad mínima */}
                  <span style={{
                      fontSize: '0.75rem',
                      color: '#6b7280'
                  }}>
                      Unid. mínima: {item.quantityStep}
                  </span>

                  {/* Precio */}
                  <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '0.25rem',
                      marginTop: 'auto'
                  }}>
                      <span style={{
                          fontSize: '0.875rem',
                          color: '#6b7280',
                          fontWeight: 400
                      }}>
                          Precio S/IVA:
                      </span>
                      <span style={{
                          fontSize: '1.75rem',
                          fontWeight: 700,
                          color: '#028322'
                      }}>
                          {item.price ? item.price.toString().replace('.', ',') + '€' : 'Inicia Sesión'}
                      </span>
                  </div>

                  {/* Formulario de añadir al carrito */}
                  <form
                      onSubmit={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          e.nativeEvent.stopImmediatePropagation();

                          ReactGA.event({
                              name: 'add_to_cart',
                              currency: 'EUR',
                              category: "ecommerce",
                              action: "add_to_cart",
                              value: item.price,
                              items: [{
                                  id: item._id,
                                  name: item.name,
                                  quantity: e.target.quantity.value,
                                  price: item.price,
                              }]
                          });

                          addToCart(e.target.productID.value, e.target.quantity.value);
                      }}
                      style={{
                          display: 'flex',
                          gap: '0.5rem',
                          marginTop: '0.5rem'
                      }}
                      onClick={(e) => e.stopPropagation()}
                  >
                      <input type="hidden" value={item._id} name="productID" />

                      <select
                          name="quantity"
                          style={{
                              flex: '0 0 80px',
                              height: '44px',
                              backgroundColor: '#fff',
                              border: '2px solid #e5e7eb',
                              borderRadius: '8px',
                              outline: 'none',
                              padding: '0 0.75rem',
                              fontSize: '0.875rem',
                              fontWeight: 600,
                              cursor: 'pointer',
                              transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                              e.target.style.borderColor = '#028322';
                          }}
                          onMouseLeave={(e) => {
                              e.target.style.borderColor = '#e5e7eb';
                          }}
                          onClick={(e) => e.stopPropagation()}
                      >
                          {Array.from({length: 25}, (v, k) => k+1).map((i, idx) => (
                              <option value={i*item.quantityStep} key={idx}>{i*item.quantityStep}</option>
                          ))}
                      </select>

                      <button
                          type="submit"
                          style={{
                              flex: 1,
                              height: '44px',
                              backgroundColor: '#028322',
                              color: '#fff',
                              border: 'none',
                              borderRadius: '8px',
                              fontSize: '0.875rem',
                              fontWeight: 600,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '0.5rem',
                              transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#027220';
                              e.currentTarget.style.transform = 'translateY(-1px)';
                              e.currentTarget.style.boxShadow = '0 4px 12px rgba(2, 131, 34, 0.3)';
                          }}
                          onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#028322';
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                          }}
                          onClick={(e) => e.stopPropagation()}
                      >
                          <BiSolidCart size={20} />
                          Añadir
                      </button>
                  </form>
              </div>
            </OfferItemContainer>
          </div>
        ))
        : (
            <>
                <div><OfferLoader/></div>
                <div><OfferLoader/></div>
                <div><OfferLoader/></div>
            </>
        )
    }
                </Carousel>
            
            {/* <DetailsContentSimilarProductsTitle>Lo más vendido</DetailsContentSimilarProductsTitle>
            <CarouselProvider
                    isIntrinsicHeight={true}
                    naturalSlideWidth={
                        getScreenWidth() > 800 ? 200 : getScreenWidth()
                    }
                    totalSlides={1}
                    visibleSlides={
                        getScreenWidth() > 800 ? 4 : 1
                    }
                    infinite={true}
                    step={1}
                    //spacing={10}
                    dragEnabled={true}
                    touchEnabled={true}
                    isPlaying={true}
                    interval={5000}
                    style={{
                        height: getScreenWidth() > 800 ? 400 : 'auto',
                    }}
                >
            <Slider

            >
                {
                    
                        
                }
            <Slide index={0}>
            <HomeItemContainer>
                <HomeItemImage
                    src="https://marlu.tpvlinker.com/thumbs/img/products/9/3/2/932_home_default.jpg"
                >
                </HomeItemImage>
                <HomeItemInfo>
                    <HomeItemTitle>MOCHILA SAFTA CLEO&CUQUIN GOOD NIGHT 34X26 L23</HomeItemTitle>
                    <HomeItemReference>Ref. 327648324</HomeItemReference>
                    <OfferItemPriceContainer>
                        <OfferItemPrice>
                        Precio S/IVA: <OfferItemOldPrice>2,97 €</OfferItemOldPrice>

                        </OfferItemPrice>
                        <OfferItemDiscount>
                            2,52 €
                        </OfferItemDiscount>
                    </OfferItemPriceContainer>

                    <OfferItemAddToCartContainer>
                        <OfferItemAddToCartButton>
                            <BiSolidCart size={24}/>
                            Añadir
                        </OfferItemAddToCartButton>
                        <OfferItemAddToCartSelect>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            </OfferItemAddToCartSelect>
                    </OfferItemAddToCartContainer>
                </HomeItemInfo>
            </HomeItemContainer>
            </Slide>
            </Slider>
            <ButtonBack
                style={{
                    position: 'relative',
                    border: 'none',
                    outline: 'none',
                    cursor: 'pointer',
                    height: '50px',
                    top: -250,
                    width: '50px',
                    display: 'flex',
                    right: 50,
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: "50%",
                    background: "transparent",
                }}
            >
                <BiChevronLeft size={48}/>
            </ButtonBack>
            <ButtonNext
                         style={{
                            background: "transparent",
                            position: 'relative',
                            border: 'none',
                            outline: 'none',
                            cursor: 'pointer',
                            height: '50px',
                            top: -300,
                            width: '50px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: "50%",
                            //align to the right
                            right: "calc(-100% + 00px)",
                            
                        }}   
            >
                <BiChevronRight size={48}/>
            </ButtonNext>
            </CarouselProvider> */}
                <DetailsContentSimilarProductsTitle>Creemos que te puede interesar
                    <a data-tooltip-id="my-tooltip" data-tooltip-content="Basándonos en tu comportamiento te ofrecemos las siguientes sugerencias">
                        <AiOutlineQuestionCircle size={22} style={{marginLeft: 5}}/>
                    </a>
                </DetailsContentSimilarProductsTitle>
                <Tooltip id="my-tooltip"
                    style={{
                        backgroundColor: '#000',
                        color: '#fff',
                        borderRadius: 5,
                        padding: 10,
                        fontSize: 14,
                        fontWeight: 400,
                        width: 300,
                    }}
                />

                <DetailsContentSimilarProductsContainer>
                    {
                        recomendation?.length > 0 ? recomendation.map((item, index) => (
                            <DetailsContentSimilarProductsItem key={index} href={'details/'+item.productURL}>
                                <DetailsContentSimilarProductsItemImage background={item.images[0]}></DetailsContentSimilarProductsItemImage>
                                <DetailsContentSimilarProductsItemTitle>
                                    {item.name}
                                </DetailsContentSimilarProductsItemTitle>
                            </DetailsContentSimilarProductsItem>
                        )) : <> </>
                    }
                </DetailsContentSimilarProductsContainer>
                {
                    loggedIn ? <> </> : (
                        <FloatingActionButton
                            text={`Hola, soy *${Math.random() > 0.5 ? "Luis Alberto" : "Alejandro"}*. ¿Por qué no me llamas y hablamos?`}
                        >
                        <BsTelephone color='#fff'
                            
                        />
                    </FloatingActionButton>
                    )
                }

        </HomeContainer>
    );
}